import axios from 'axios'
import { Toast } from 'antd-mobile';
// create an axios instance
const service = axios.create({
  baseURL:'https://tcxh.ruiyiok.cn/api/v1/',
  // baseURL:'https://jzclxh.ruiyiok.cn/api/v1/',
  timeout: 8000 // request timeout
})

//请求拦截器
service.interceptors.request.use(
  config => {
    // console.log(config)
    if(config.url==='/upload/img'){
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    Toast.show({icon: 'loading',content: '加载中...'})
    let token = localStorage.token||''; 
    config.headers['token'] = token;
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return error
    // return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    Toast.clear();
    if(response.data.code===0){
        return response.data;
    }else if(response.data.code===305){
        Toast.show({icon: 'fail',content: response.data.msg})
        // setTimeout(()=>{
          localStorage.clear()
          window.location.href="/h5/#/login";
        // },1000)
    }
    else{
        console.log("出错");
        return response.data;
    }
  },
  error => {
    Toast.clear();
    Toast.show({icon: 'fail',content: '网络异常，请稍后再试！'})
    return {errmsg:"网络异常，请稍后再试！"};
  }
)


export default service
